import './ConfirmDetails.css';
import { useContext, useEffect, useState } from 'react';
import { API, Endpoints } from '../api/API';
import BASECONFIG from '../config.json';
import { BasicInfo, Facility, Institution, RegistrationValue, init_Facility } from '../interfaces/Interfaces';
import { getConfirmDetailsDisplay } from './Applications';
import { userDataCtx } from '../hooks/applicationData';

interface ConfirmDetailsProps {
    email: string,
    basicInfo: BasicInfo,
    facilityInfo: Facility,
    facZip: string,
    institute: Institution,
    formStep: number
    setFormStep: React.Dispatch<React.SetStateAction<number>>,
    userType: "customer" | "independent" | "student" | null,
    lang: string | null,
    userCountry: string | null,
    objectId: string | null,
    appId: string | null,
    translate: () => void,
    setBackgroundWIP: React.Dispatch<React.SetStateAction<boolean>>,
    bdBioSciencesUserType: string | null,
    getJWTDriver: () => Promise<boolean>,
    CONFIG: any,
    countries?: Record<string, string>,
    positions: Array<[string, string]>,
    token: string,
    institutionLinkAlwaysOptional: boolean | false,
    skipOptionalInstitutionLink: boolean | false,
    authLocale: string,
    customRegistrationValues: Array<RegistrationValue>,
    updateRegistrationValues: () => void
    appFeatures: any,
    hideFields: Array<string>,
    optionalFields: Array<string>
}

const ConfirmDetails = (props: ConfirmDetailsProps) => {

    
    const CONFIG = process.env.NODE_ENV === 'production' ? BASECONFIG.production : BASECONFIG.development;
    const [showJWTError, setShowJWTError] = useState(false);
    const [appDetails, appDetailsNeeded] = getConfirmDetailsDisplay(props);
    const {data:addData} = useContext(userDataCtx);
    
    useEffect(() => {
        props.translate();
        // select role based on lang
        
    }, [props.lang]);

    useEffect(() => {
        props.updateRegistrationValues();
    }, [props.customRegistrationValues]);

    const goBack = () => {
        props.setFormStep(props.formStep - 1);
    }

    const onSave = async () => {
        props.setBackgroundWIP(true);
        setShowJWTError(false);
        let facilityInfo = JSON.stringify(props.facilityInfo) !== JSON.stringify(init_Facility) ? [{ ...props.facilityInfo }] : [];
        const currentDate = new Date();
        const epochTime = Math.floor(Date.now() / 1000); 
        var body: any = {
            id: props.objectId,
            country: props.userCountry,
            email: props.email,
            firstName: props.basicInfo.firstName,
            lastName: props.basicInfo.lastName,
            phoneNumber: props.basicInfo.phoneNumber,
            userType: props.userType,
            isActive: props.basicInfo.isActive,
            defaultLanguage: props.lang,
            global: {
                "mobileNumber": props.basicInfo.mobileNumber,
                "faxNumber": props.basicInfo.faxNumber,
                "position": props.basicInfo.position,
                "accountNumber": props.basicInfo.accountNumber,
                "facilities": facilityInfo,
                "institution": { ...props.institute },
                "zipCode": props.facZip,
                "department": props.basicInfo.department,
                "authLocale":props.authLocale,
                "dateOfConsent": epochTime
                          
            }
        };
        
        if (appDetailsNeeded) {
            body.applications = {
                [props.appId!]: addData
            }
        }
        try {
            const status = await API.POST(body, Endpoints.SaveUserData, props.token);
            if (!status) {
                console.log("Save user error");
                props.setBackgroundWIP(false);
            } else {
                let resp = await props.getJWTDriver();
                if (!resp) {
                    setShowJWTError(true);
                }
            }
        } catch (e) {
            console.log(e);
            props.setBackgroundWIP(false);
        }
    }

    return (
        <div id="confirm-details-container">
            {showJWTError ? <div className='error 99491c4e-2d49-48d9-8177-7679742e4766'>There was an issue processing your request, please try again. If the issue persists please contact support.</div> : <></>}
            <form>
                <div>
                    <h2 className="a5c3e18d-52d8-49a0-bb87-6eff2eb60686"> Basic Information </h2>
                    <div className="row">
                        <div className="col-sm-6">
                            <p>
                                <span> <div className="f64966de-fb23-4f0a-bd72-2a22b15a2295">Email</div>: </span> {props.email}
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p>
                                <span> <div className="eb0ec150-5121-4f68-a591-2a2608f1d3c3">Country</div>:</span> {props.countries ? props.countries[props.userCountry!.toLowerCase()] : props.userCountry}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={!props.hideFields?.includes("firstName")? "col-sm-6" :"hide"}>
                            <p>
                                <span className="732ee312-80ce-4fac-9dfd-b5ab7565cc12">Firstname</span> {props.basicInfo.firstName ? props.basicInfo.firstName : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                        <div className={!props.hideFields?.includes("lastName")? "col-sm-6" :"hide"}>
                            <p>
                                <span className="4c6584dc-36eb-4508-b48f-ed3f71eefb6f">Lastname</span> {props.basicInfo.lastName ? props.basicInfo.lastName : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={!props.hideFields?.includes("phoneNumber")? "col-sm-6" :"hide"}>
                            <p>
                                <span className="bc9dcd06-422b-498c-845e-c71fe224dee0">Phone number</span> {props.basicInfo.phoneNumber ? props.basicInfo.phoneNumber : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                        <div className={!props.hideFields?.includes("mobileNumber")? "col-sm-6" :"hide"}>
                            <p>
                                <span className="f4cd64eb-089d-4dd3-b2d9-094203bb2bac">Mobile number</span> {props.basicInfo.mobileNumber ? props.basicInfo.mobileNumber : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={!props.hideFields?.includes("faxNumber")? "col-sm-6" :"hide"}>
                            <p>
                                <span className="15d8612e-f30c-45ff-87ff-d5ce264d18ca">Fax number</span> {props.basicInfo.faxNumber ? props.basicInfo.faxNumber : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                        <div className={!props.hideFields?.includes("position")? "col-sm-6" :"hide"}>
                            <p>
                                <span> <div className="1d1d5243-811c-4e30-a61e-c06fe8ea8a46">Position</div>:</span> {props.basicInfo.position ? props.positions.find(pos => props.basicInfo.position === pos[0])![1] : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={!props.hideFields?.includes("accountNumber")? "col-sm-6" :"hide"}>
                            <p>
                                <span> <div className="f57c2053-d083-4d35-82c7-b416f11b69c5">Account number</div>:</span> {props.basicInfo.accountNumber ? props.basicInfo.accountNumber : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                        <div className={!props.hideFields?.includes("department")? "col-sm-6" :"hide"}>
                            <p>
                                <span> <div className="a8dd35a7-7c5a-4667-95b4-f93a185f5d64">Department</div>:</span> {props.basicInfo.department ? props.basicInfo.department : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className={!props.hideFields?.includes("facilityZip")? "col-sm-6" :"hide"}>
                            <p>
                                <span> <div className="efc78a94-b051-4156-b47d-11b342f497db">Zip Code</div>:</span> {props.facZip ? props.facZip : <span className="none e8a42329-3df6-4848-9732-c43aad2ed125">None</span>}
                            </p>
                        </div>
                    </div>
                    <div className={props.appId === CONFIG.bdBiosciences ? "row" : "hide"}>
                        <div className={props.appId === CONFIG.bdBiosciences ? "col-sm-6" : "hide"}>
                            <p>
                                BD Bioscience <span className="7386ff38-9394-44dc-b90a-b4c00762ec13">User Type: </span> {props.bdBioSciencesUserType}
                            </p>
                        </div>
                    </div>
                </div>
                {(props.userType === "student" && props.institute.name !== "") ?
                    (<div>
                        <h2 className="fd55a358-0575-4df0-89b6-956ee7078ff6"> Institution Information </h2>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="3067d2a7-571e-4195-b6f0-a4d2215352d1">Institution Name:</span> {props.institute.name}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="70f0e5b9-688c-438a-9c51-1d60b531aab5">Institution Address Line 1:</span> {props.institute.address1}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="72aa28bd-f660-429f-9a86-8cd19e199adf">Institution Address Line 2:</span> {props.institute.address2}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="a70ac1ec-051c-4e7f-a8f5-6ad76ffa5ed5">Institution City:</span> {props.institute.city}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="f2563706-07f8-4ae3-87e6-a812cc73419e">Institution State:</span> {props.institute.state}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="d6c2cb84-1449-4cf0-bdb9-fd267b9d3453">Institution Country:</span> {props.countries ? props.countries[props.institute.country.toLowerCase()] : props.institute.country}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="a1bcc616-89aa-46ae-ad20-a7326112c864">Institution Zipcode:</span> {props.institute.zipCode}
                                </p>
                            </div>
                        </div>
                    </div>)
                    : JSON.stringify(props.facilityInfo) !== JSON.stringify(init_Facility) ?
                    (<div>
                        <h2 className="c63f87ff-83bb-4386-b6dd-2ee5ae2d51ca"> Facility Information </h2>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="db339b59-6aba-4a19-9042-bd60c076e2bc">Facility name:</span> {props.facilityInfo.facilityName}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="2e59ed8e-afd6-4b93-92a5-eaf40f39a7f9">Facility address:</span> {props.facilityInfo.facilityAddress}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="1c4a98f9-1402-4118-beca-6a0ba6086491">Facility city:</span> {props.facilityInfo.facilityCity}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="548a1152-3a22-4087-8d70-f90d2ba88d51">Facility state:</span> {props.facilityInfo.facilityState}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <span className="3352fe31-c787-4655-a9ca-5c91d68ef94a">Facility country:</span> {props.countries ? props.countries[props.facilityInfo.facilityCountry.toLowerCase()] : props.facilityInfo.facilityCountry}
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <span className="bd66450d-20b9-4d53-8316-3cdae9fc5b59">Facility Zipcode:</span> {props.facilityInfo.facilityZip}
                                </p>
                            </div>
                        </div>
                    </div>) : (<></>)
                }
                {appDetailsNeeded && <div>{appDetails}</div>}
            </form>
            <div className="spacer"></div>
            <p className="buttons align-right">
                <button id="continue" className="button cfb63e0a-7122-45c2-88ab-c7b63920676b" onClick={onSave} >Register</button>
                <button className="gray button 041b8acf-fafc-450f-8111-d7d0c36bba6b" onClick={goBack}>Back</button>
            </p>
        </div>
    )
}

export default ConfirmDetails;
